<template>
  <div class="h-full">
    <ActivityContainer :activities="activities" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ActivityContainer from '@c/Activity/ActivityContainer.vue'

export default {
  name: 'EventActivityPage',
  components: {
    ActivityContainer
  },
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activities: []
    }
  },
  mounted() {
    this.fetchActivities()
  },
  methods: {
    ...mapActions({
      processFetchEventActivityAction: 'planning/fetchEventActivityByEventID'
    }),
    fetchActivities() {
      this.processFetchEventActivityAction({
        event_id: this.eventId
      }).then((response) => {
        this.activities = response.activities
      })
    }
  }
}
</script>
